import { httpClient } from '../../config';

export const fetchBrands = async () => {
  try {
    const { json } = await httpClient('/tables/active_entities/brands');
    return json;
  } catch (error) {
    console.error('Failed to fetch brand data:', error);
    throw error;
  }
};
